import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import NumberInput from 'fe-design-base/atoms/NumberInput';
import Text from 'fe-design-base/atoms/Text';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

import { isInvalidValue, numberToCurrency } from './util';

const { cx } = cxHelpers('CreditTips');

const CreditTips = ({
  creditTips,
  creditTipOutEligible,
  handleChangeCreditTips,
  trackTipsClick,
}) => (
  <Box className={cx()} column>
    <Box w={100} onClick={partial(trackTipsClick, 'credit_tips')}>
      <Box pb={8}>
        <Text
          color="mono700"
          textAlign="left"
          variant="bodySmBoldTight"
          i18n="timecard_modal_v3.tips_edit_section.credit_tips"
        />
      </Box>
      {creditTipOutEligible ? (
        <Box pv={8} vcenter>
          <Text variant="body" color="mono900">
            {numberToCurrency(creditTips ?? 0)}
          </Text>
        </Box>
      ) : (
        <NumberInput
          name="credit_tips"
          size="medium"
          value={creditTips}
          error={isInvalidValue(creditTips)}
          onChange={handleChangeCreditTips}
          placeholder="$0.00"
          places="2"
          prefix="$"
          leftAlign
          dataTestId="creditTipsInput"
        />
      )}
    </Box>
  </Box>
);

CreditTips.propTypes = {
  creditTips: PropTypes.number,
  creditTipOutEligible: PropTypes.bool,
  trackTipsClick: PropTypes.func.isRequired,
  handleChangeCreditTips: PropTypes.func.isRequired,
};

export default CreditTips;
